import { useEffect, useState } from 'react';
import { Configuration } from '../../../../clients/quipli-service/configuration/configuration';
import { useAPI } from '../../../../clients/quipli-service/quipli-service-client';

export const useStatusTransitionConfig = () => {
  const { getConfiguration } = useAPI();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [allowCombinedOffRentReturn, setAllowCombinedOffRentReturn] = useState<Configuration>();

  useEffect(() => {
    setIsLoading(true);
    getConfiguration('CONF_ALLOW_COMBINED_OFF_RENT_RETURN')
      .then(setAllowCombinedOffRentReturn)
      .finally(() => setIsLoading(false));
  }, []);

  return {
    isLoading,
    allowCombinedOffRentReturn,
  };
};
